import loadable from "loadable-components";

const NotFoundErrorPageRoute = loadable(() =>
  import(
    /* webpackPreload: true, webpackChunkName: "nf" */ "../NotFoundErrorPage"
  )
);

export default NotFoundErrorPageRoute;
